import ssublet from "../assets/img/ssublet.jpg";
import runaway from "../assets/img/pr1.jpg";
import ready from "../assets/img/ready.png";
import sublive from "../assets/img/sublive.jpg";

const projectData = [
  {
    id: 1,
    name: "Runaway",
    category: "Mobile and Web App",
    description:
      "Runaway App is a platform where people in need of help or support can live chat with a trained volunteer",
    image: runaway,
    imageAlt: "runaway",
    url: "",
    altUrl: "",
    right: false
  },
  {
  id: 2,
  name: "SubLive",
  category: "Browser Extension",
  description:
    "Winning Google's Best Use of Google Cloud Award, SubLive is a browser extension project aimed to provide real time transcriber specifically for virtual learning environments.",
  image: sublive,
  imageAlt: "sublive",
  url: "",
  altUrl: "",
  right: true
  },
  {
    id: 3,
    name: "Ready",
    category: "Mobile - Web App",
    description:
      "My UI/UX practice project. Not a fully working app, but just the frontend mobile and web application. Contact me for full mock!",
    image: ready,
    imageAlt: "ready-screenshot",
    url: "",
    altUrl: "",
    right: false
  },
];

export default projectData;
